import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
} from "@remix-run/react";
import PosthogAnalytics from "./components/posthog";
import SentryInit from "./components/sentry";
import {json} from "@remix-run/node";

export const loader = async () => {
  return json({
    POSTHOG_API_KEY: process.env.POSTHOG_API_KEY,
    SENTRY_DSN: process.env.SENTRY_DSN,
  });
}

export default function App() {
  const loaderData = useLoaderData();

  return (
    <html>
    <head>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />
      <link rel="preconnect" href="https://cdn.shopify.com/" />
      <link
        rel="stylesheet"
        href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
      />
      <Meta />
      <Links />
    </head>
    <body>
    <Outlet />
    <ScrollRestoration />
    <PosthogAnalytics apiKey={loaderData?.POSTHOG_API_KEY} />
    <SentryInit sentryDsn={loaderData?.SENTRY_DSN} />
    <Scripts />
    </body>
    </html>
  );
}
